"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The infinite loader.
 */
exports.default = (function (_a) {
    var size = _a.size, color = _a.color;
    return "\n    <svg width=\"".concat(size[0], "\" height=\"").concat(size[1], "\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=\"none\" stroke=\"").concat(color, "\" stroke-width=\"8\" stroke-dasharray=\"42 42\" d=\"M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z\" stroke-linecap=\"round\">\n            <animate attributeName=\"stroke-dashoffset\" repeatCount=\"indefinite\" dur=\"1s\" keyTimes=\"0;1\" values=\"0;256\"></animate>\n        </path>\n    </svg>\n");
});
